import { render } from "./InstallProduct.vue?vue&type=template&id=68d3e6c1"
import script from "./InstallProduct.vue?vue&type=script&lang=js"
export * from "./InstallProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__